<script setup lang="ts">
import { PhCheckCircle, PhWarning, PhX, PhXCircle } from "@phosphor-icons/vue";

defineProps<{
  alertId: string;
  closeId: string;
  closeLabel: string;
  textId: string;
}>();
</script>

<template>
  <div :id="alertId" class="status-alert" data-tone="success" role="status" aria-live="polite" hidden>
    <span class="status-alert-icon" aria-hidden="true">
      <PhCheckCircle class="status-alert-symbol status-alert-symbol--success" :size="14" weight="bold" />
      <PhWarning class="status-alert-symbol status-alert-symbol--warning" :size="14" weight="bold" />
      <PhXCircle class="status-alert-symbol status-alert-symbol--error" :size="14" weight="bold" />
    </span>
    <span :id="textId" class="status-alert-text"></span>
    <button
      :id="closeId"
      class="status-alert-close"
      type="button"
      :aria-label="closeLabel"
      :title="closeLabel"
    >
      <PhX :size="14" weight="bold" aria-hidden="true" />
    </button>
  </div>
</template>
